(function () {
    function ready(fn) {
        if (document.readyState !== 'loading') fn();
        else document.addEventListener('DOMContentLoaded', fn);
    }

    function show(el) { if (el) el.hidden = false; }
    function hide(el) { if (el) el.hidden = true; }

    function setup(el) {
        const input = el.querySelector('[ref="searchInput"]');
        const resetBtn = el.querySelector('[ref="resetButton"]');
        const searchBtn = el.querySelector('[ref="searchButton"]');
        if (!input) return;

        const searchBase = el.dataset.searchUrl || '/search';

        const updateReset = () => {
            if (input.value.trim().length > 0) show(resetBtn);
            else hide(resetBtn);
        };

        const goSearch = () => {
            const q = input.value.trim();
            if (!q) { input.focus(); return; }
            const url = new URL(searchBase, location.origin);
            url.searchParams.set('q', q);
            window.location.href = url.toString();
        };

        input.addEventListener('input', updateReset);
        input.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                e.preventDefault();
                input.value = '';
                updateReset();
                input.focus();
            } else if (e.key === 'Enter') {
                e.preventDefault();
                goSearch();
            }
        });

        if (resetBtn) {
            resetBtn.addEventListener('click', (e) => {
                e.preventDefault();
                input.value = '';
                updateReset();
                input.focus();
            });
        }

        if (searchBtn) {
            searchBtn.addEventListener('click', (e) => {
                e.preventDefault();
                goSearch();
            });
        }

        updateReset();
    }

    ready(() => {
        document.querySelectorAll('predictive-search-component').forEach(setup);
    });
})();